module.exports = __webpack_public_path__ + "img/product-5.c7367627.jpg";